import { Link } from "react-router-dom";
import type { Article } from "@/types/news";
import { formatViews, relativeTime } from "@/utils/news";
import CategoryBadge from "@/components/feature/CategoryBadge";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article
      className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
    >
      <Link to={`/detail/${article.id}`} className="flex cursor-pointer flex-col sm:flex-row">
        <div className="relative h-48 w-full shrink-0 overflow-hidden bg-background-100 sm:h-auto sm:w-56">
          <img
            src={article.coverImage}
            alt={`${article.title} - 51吃瓜网站资讯配图`}
            title={`${article.title} - 51吃瓜网站`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-1 flex-col p-4 md:p-5">
          <div className="mb-2 flex flex-wrap items-center gap-2">
            <CategoryBadge categoryKey={article.category} />
            <span className="text-xs text-foreground-400">
              {relativeTime(article.publishedAt)}
            </span>
          </div>
          <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
            {article.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {article.summary}
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-user-3-line"></i>
              {article.author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(article.views)} 次浏览
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}